var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTableMenuActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 8,
    viewBox: "0 0 26 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 513365"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.66667C0 1.6416 1.64163 0 3.66667 0C5.69171 0 7.33333 1.6416 7.33333 3.66667C7.33333 5.69173 5.69171 7.33333 3.66667 7.33333C1.64163 7.33333 0 5.69173 0 3.66667ZM3.66667 2C2.74619 2 2 2.74613 2 3.66667C2 4.5872 2.74619 5.33333 3.66667 5.33333C4.58715 5.33333 5.33333 4.5872 5.33333 3.66667C5.33333 2.74613 4.58715 2 3.66667 2Z",
    fill: "#0A7F8F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33301 3.66667C9.33301 1.6416 10.9746 0 12.9997 0C15.0247 0 16.6663 1.6416 16.6663 3.66667C16.6663 5.69173 15.0247 7.33333 12.9997 7.33333C10.9746 7.33333 9.33301 5.69173 9.33301 3.66667ZM12.9997 2C12.0791 2 11.333 2.74613 11.333 3.66667C11.333 4.5872 12.0791 5.33333 12.9997 5.33333C13.9202 5.33333 14.6663 4.5872 14.6663 3.66667C14.6663 2.74613 13.9202 2 12.9997 2Z",
    fill: "#0A7F8F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3337 0C20.3086 0 18.667 1.6416 18.667 3.66667C18.667 5.69173 20.3086 7.33333 22.3337 7.33333C24.3587 7.33333 26.0003 5.69173 26.0003 3.66667C26.0003 1.6416 24.3587 0 22.3337 0ZM20.667 3.66667C20.667 2.74613 21.4131 2 22.3337 2C23.2542 2 24.0003 2.74613 24.0003 3.66667C24.0003 4.5872 23.2542 5.33333 22.3337 5.33333C21.4131 5.33333 20.667 4.5872 20.667 3.66667Z",
    fill: "#0A7F8F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableMenuActive);
export default __webpack_public_path__ + "static/media/table_menu_active.c925d04e49947dd3b6888dab6fd37697.svg";
export { ForwardRef as ReactComponent };